const SET_OPS = ['eq', 'in', 'not_in', 'is_null', 'not_null'];
const RANGE_OPS = ['between', 'gte', 'lte', 'gt', 'lt'];
const TEXT_OPS = ['contains', 'starts_with'];
/** Number types: one integer per fact row. */
export const NUMBER_TYPES = ['count', 'money', 'duration', 'distance'];
/** The calendar ordinals a range makes sense over. */
export const ORDINAL_TYPES = ['hour', 'weekday'];
export const isNumberType = (t) => NUMBER_TYPES.includes(t);
export const isOrdinalType = (t) => ORDINAL_TYPES.includes(t);
/** The operators a condition on `def` may use. */
export function operatorsFor(def) {
    // A RECORD-LEVEL number (one value per fact row) is asked in ranges only: an exact value (`eq`, `in`, `not_in`) pins one transaction, and with a
    // distinct-people count it would answer "do these two known orders share a customer?" (D528 review P1-1). Null tests name nobody and stay.
    if (def.recordLevel === true)
        return ['is_null', 'not_null', ...RANGE_OPS];
    if (isNumberType(def.valueType))
        return [...SET_OPS, ...RANGE_OPS];
    if (isOrdinalType(def.valueType))
        return ['eq', 'in', 'not_in', ...RANGE_OPS];
    if (def.valueType === 'flag')
        return ['eq', 'in', 'not_in'];
    if (def.personal || (def.valueType !== 'ref' && def.valueType !== 'code'))
        return SET_OPS;
    return [...SET_OPS, ...TEXT_OPS];
}
/** Can the dimension's values be listed with counts? (Not a number, not the day-level calendar, never the order grain.) */
export function isEnumerable(def) {
    if (def.filterOnly === true || isNumberType(def.valueType))
        return false;
    return !['day', 'month', 'quarter', 'year', 'orderRef'].includes(def.valueType);
}
//# sourceMappingURL=operators.js.map